import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { ContainerComponent } from '../components/container/container.component';
import { ResizableSplitLayoutComponent } from '../components/resizable-split-layout/resizable-split-layout.component';
import { SidebarButtonsItemComponent } from '../components/sidebar-buttons/sidebar-buttons-item/sidebar-buttons-item.component';
import { SidebarButtonsComponent } from '../components/sidebar-buttons/sidebar-buttons.component';
import { AdminGate } from '../guards/admin-gate';

const ADMIN_PAGES = [
  {
    id: 'general',
    titleKey: 'admin.general.tab',
    icon: <TuneOutlinedIcon />,
  },
  {
    id: 'mcp',
    titleKey: 'admin.mcp.tab',
    icon: <HubOutlinedIcon />,
  },
  {
    id: 'users',
    titleKey: 'admin.users.tab',
    icon: <PeopleOutlinedIcon />,
  },
  {
    id: 'tool-presets',
    titleKey: 'admin.toolPresets.tab',
    icon: <ExtensionOutlinedIcon />,
  },
  {
    id: 'tool-settings',
    titleKey: 'admin.toolSettings.tab',
    icon: <BuildOutlinedIcon />,
  },
  {
    id: 'contentful-tags',
    titleKey: 'admin.contentfulTags.tab',
    icon: <LocalOfferOutlinedIcon />,
  },
  {
    id: 'skills',
    titleKey: 'admin.skills.tab',
    icon: <AutoStoriesOutlinedIcon />,
  },
] as const;

export function AdminPage() {
  const { t } = useTranslation();

  return (
    <AdminGate>
      <ResizableSplitLayoutComponent
        left={
          <SidebarButtonsComponent>
            <Typography variant="h5">{t('admin.title')}</Typography>
            {ADMIN_PAGES.map((page) => (
              <SidebarButtonsItemComponent
                key={page.id}
                title={t(page.titleKey)}
                icon={page.icon}
                to={`/admin/${page.id}`}
              />
            ))}
          </SidebarButtonsComponent>
        }
        right={
          <ContainerComponent>
            <Outlet />
          </ContainerComponent>
        }
      />
    </AdminGate>
  );
}
